export const GCP_INTEGRATION = {
  TITLE: 'Conecta tus proyectos de GCP',
  ERRORS: {
    SAVE_ERROR: 'Error al finalizar la integración, por favor intenta de nuevo o contacta a soporte',
    UPLOAD_KEY_ERROR: 'Error al subir la clave, por favor intenta de nuevo o contacta a soporte',
  },
  SUCCESS: {
    INTEGRATION_COMPLETED: 'Integración completada exitosamente',
  },
  STEP1: {
    HELPER_TAG: 'Elige si deseas integrar uno o múltiples proyectos',
    SINGLE_PROJECT: {
      TITLE: 'Un solo proyecto de GCP',
      DESCRIPTION: 'Ideal si gestionas todo desde un solo proyecto de GCP.',
    },
    MULTI_PROJECT: {
      TITLE: 'Múltiples proyectos de GCP',
      DESCRIPTION: 'Para configuraciones multi-proyecto u organizaciones',
    },
  },
  STEP2_SINGLE: {
    HELPER_TAG: 'Proporciona los metadatos de tu proyecto de GCP para comenzar el proceso.',
    PROJECT_ID_LABEL: 'ID de proyecto de GCP',
    PROJECT_ID_HELPER: 'Identificador único del proyecto',
    PROJECT_ID_ERROR: 'Por favor ingresa tu ID de proyecto',
    PROJECT_NAME_LABEL: 'Nombre visible del proyecto',
    PROJECT_NAME_HELPER: 'Usado dentro de Qalea',
    PROJECT_NAME_ERROR: 'Por favor ingresa un nombre visible para el proyecto',
  },
  STEP2_MULTI: {
    HELPER_TAG: 'Describe los proyectos de GCP que deseas gestionar.',
    HOME_PROJECT_ID_LABEL: 'ID del proyecto principal',
    HOME_PROJECT_NAME_LABEL: 'Nombre del proyecto principal',
    PROJECT_ID_LABEL: 'ID de proyecto',
    PROJECT_NAME_LABEL: 'Nombre del proyecto',
    ADD_PROJECT: 'Añadir otro proyecto',
    AT_LEAST_ONE_PROJECT_ERROR: 'Por favor ingresa al menos un proyecto con ID y nombre',
  },
  STEP3_SINGLE: {
    HELPER_TAG: 'Habilita las APIs requeridas en tu proyecto de GCP.',
    ENABLE_MANUALLY_TITLE: 'Habilita las APIs manualmente',
    ENABLE_MANUALLY_DESCRIPTION: 'Abre cada API manualmente en la consola y habilítalas.',
    OPEN_IN_CONSOLE: 'Abrir en Consola',
    OR_DIVIDER: 'o',
    RUN_COMMAND: 'Ejecuta el siguiente comando',
    PREREQS_DESCRIPTION: 'Ejecuta este comando para habilitar las APIs necesarias para la integración de Qalea.',
    API_CHECKLIST: {
      CLOUD_RESOURCE_MANAGER: 'Cloud Resource Manager API',
      SERVICE_USAGE: 'Service Usage API',
      COMPUTE_ENGINE: 'Compute Engine API',
    },
  },
  STEP3_MULTI: {
    HELPER_TAG: 'Habilita las APIs requeridas en todos tus proyectos de GCP.',
    ENABLE_MANUALLY_TITLE: 'Habilita las APIs manualmente para cada proyecto',
    HOME_BADGE: 'Principal',
    OR_DIVIDER: 'o',
    RUN_COMMAND: 'Ejecuta el siguiente comando',
    PREREQS_DESCRIPTION: 'Ejecuta este comando para habilitar las APIs necesarias en todos los proyectos.',
    API_CHECKLIST: {
      CLOUD_RESOURCE_MANAGER: 'Cloud Resource Manager API',
      SERVICE_USAGE: 'Service Usage API',
      COMPUTE_ENGINE: 'Compute Engine API',
    },
  },
  STEP4_SINGLE: {
    HELPER_TAG: 'Crea una cuenta de servicio y otórgale los permisos necesarios.',
    CLI_TAB: 'CLI',
    TERRAFORM_TAB: 'Terraform',
    CLI_TITLE: 'Crear cuenta de servicio vía gcloud CLI',
    TERRAFORM_TITLE: 'Crear cuenta de servicio vía Terraform',
  },
  STEP4_MULTI: {
    HELPER_TAG: 'Crea una cuenta de servicio en tu proyecto principal y otórgale acceso a todos los proyectos.',
    CLI_TAB: 'CLI',
    TERRAFORM_TAB: 'Terraform',
    CLI_TITLE: 'Crear cuenta de servicio vía gcloud CLI',
    TERRAFORM_TITLE: 'Crear cuenta de servicio vía Terraform',
  },
  STEP5: {
    HELPER_TAG: 'Sube o pega el archivo de clave JSON generado en el paso anterior.',
    UPLOAD_TITLE: 'Subir archivo de clave JSON',
    UPLOAD_BUTTON: 'Seleccionar archivo',
    PASTE_LABEL: 'Pega el contenido del archivo de clave JSON',
    UPLOAD_ERROR: 'Por favor sube o pega una clave JSON válida',
    OR_DIVIDER: 'o',
  },
  FOOTER: {
    CANCEL: 'Cancelar',
    CONTINUE: 'Continuar',
    BACK: 'Atrás',
    UPLOAD: 'Subir clave',
  },
  STEP_PROGRESS_SINGLE: [
    'Tipo de Proyecto',
    'Detalles del Proyecto',
    'Habilitar APIs',
    'Cuenta de Servicio',
    'Subir Clave',
  ],
  STEP_PROGRESS_MULTI: [
    'Tipo de Proyecto',
    'Detalles del Proyecto',
    'Habilitar APIs',
    'Cuenta de Servicio',
    'Subir Clave',
  ],
}
